<div class="text-center mt-5 mb-2">
    <img :src="$clientLogo" width="200px" />
</div>